export const UNAVAILABLE_SLOTS_TYPES = Object.freeze({
  medicalAppointment: 0,
  vacation: 1,
  leave: 2,
  reducedSchedule: 3,
  other: 4,
  lockedTime: 5,
})

export const UNAVAILABLE_SLOT_TRANSLATION = Object.freeze({
  [UNAVAILABLE_SLOTS_TYPES.reducedSchedule]: 'unavailableSlot.reducedSchedule',
  [UNAVAILABLE_SLOTS_TYPES.medicalAppointment]:
    'unavailableSlot.medicalAppointment',
  [UNAVAILABLE_SLOTS_TYPES.vacation]: 'unavailableSlot.vacation',
  [UNAVAILABLE_SLOTS_TYPES.leave]: 'unavailableSlot.leave',
  [UNAVAILABLE_SLOTS_TYPES.lockedTime]: 'unavailableSlot.lockedTime',
  [UNAVAILABLE_SLOTS_TYPES.other]: 'unavailableSlot.other',
})

/**
 * Obtiene la clave de traducción para un tipo de unavailable slot.
 * Si el tipo no está en el rango válido (0-5), retorna 'appointmentType.absences'.
 * @param {number} slotType - El tipo de unavailable slot
 * @returns {string} La clave de traducción
 */
export const getUnavailableSlotTranslationKey = (slotType) => {
  return UNAVAILABLE_SLOT_TRANSLATION[slotType] || 'appointmentType.absences'
}
